function errorText(error: unknown) {
  if (error instanceof Error) return error.message;
  if (typeof error === "object" && error && "message" in error && typeof error.message === "string") {
    return error.message;
  }
  return "";
}

export function encryptedRelayErrorMessage(error: unknown) {
  const message = errorText(error);
  if (message.includes("Every target member needs an active device encryption key")) {
    return "这条星河有成员的设备还没完成安全准备。请在对方的 Windows、Android 客户端或浏览器设备登录同一账号并保持联网片刻，再重新保存。";
  }
  if (message.includes("The source device must be active and have an encryption key")) {
    return "这台设备还没完成安全准备。请保持联网，返回星河后稍等片刻再重新保存。";
  }
  if (message.includes("Encrypted transfer envelopes do not match the recipient device snapshot")) {
    return "授权设备刚发生变更，正在刷新安全信息。请返回星河后重新进入此页面再保存。";
  }
  return null;
}
